import React from 'react';
import {
  Grid,
  Direction,
  Column,
  Margin,
  Hero,
  Text
} from '@scotia/canvas-react';
import PropTypes from 'prop-types';

import { TitleBackgroundImage } from './TitleBackgroundImage';
import { Divider } from '../Divider';
import { Alignment } from '../Alignment';

/** Information Layout, part of Canvas Patterns.
 * It's been used as a landing page at the start of a multi step flow.
 */
export const PageTitle = ({
  title,
  message,
  icon,
  children,
  hideIconBackground,
  ...rest
}) => (
  <Grid center {...rest}>
    <Margin xs={12} sm={24} lg={60} side="top">
      <Direction>
        <Column lg={8} md={8} sm={8} xs={12} smOffset={2}>
          <TitleBackgroundImage
            align="center"
            hideIconBackground={hideIconBackground}
          >
            {icon}
          </TitleBackgroundImage>
        </Column>
      </Direction>
    </Margin>
    <Margin xs={36} sm={36} lg={36} side="top">
      <Direction>
        <Column lg={6} md={6} sm={6} xs={12} smOffset={3}>
          <Alignment xs="center">
            <Hero>{title}</Hero>
          </Alignment>
        </Column>
      </Direction>
    </Margin>
    <Margin xs={12} sm={12} lg={12} side="top">
      <Divider align="center" />
    </Margin>
    <Margin xs={12} sm={12} lg={12} side="both">
      <Direction>
        <Column lg={8} md={8} sm={8} xs={10} smOffset={2} xsOffset={1}>
          <Alignment xs="center">
            <Text>{message}</Text>
          </Alignment>
        </Column>
      </Direction>
    </Margin>
    {children}
  </Grid>
);

PageTitle.propTypes = {
  /** Title to be displayed */
  title: PropTypes.string.isRequired,
  /** Message to be displayed under the title */
  message: PropTypes.string.isRequired,
  /** Icon to be displayed on top */
  icon: PropTypes.node.isRequired,
  /** Hide backgroud of the icon */
  hideIconBackground: PropTypes.bool
};
